import api from "../api";
import {Resturent_endpoint,Slider_endpoint,Category_endpoint,Slug_endpoint,Single_Item_endpoint,Checkout_endpoint,Register_endpoint,Login_endpoint,GetProfile_endpoint,AddFavorite_endpoint,Wallet_endpoint,Payment_endpoint,Order_endpoint,defaultAddress_endpoint} from '../api_endpoints'
const {GETRESTURENT_API,GETRESTURENT_CATEGORY_API} = Resturent_endpoint;
const {SLIDER_API}=Slider_endpoint;
const {CATEGORY_API}=Category_endpoint;
const {SLUG_API,SLUGITEM_API}=Slug_endpoint;
const { SINGLE_ITEM_API}=Single_Item_endpoint;
const { CHECKOUT_API}=Checkout_endpoint;
const {REGISTER_API}=Register_endpoint;
const {LOGIN_API}=Login_endpoint;
const {ADDFAVORITE_API,FAVORITE_API}=AddFavorite_endpoint;
const {WALLET_API,COUPON_API}=Wallet_endpoint;
const {GETPROFILE_API,GETPAGES_API,SAVEADDRESS_API,AVATURE_API,GETADDRESS_API,DELETEADDRESS_API,MYORDER_API}=GetProfile_endpoint;
const {PAYMENT_API,PLACEORDER_API}=Payment_endpoint;
const {CANCELORDER_API}=Order_endpoint;
const {DEFAULTADDRESS_API}=defaultAddress_endpoint;

export const ResturentDetails = async (data) => {
    let result = [];
    try {
        const response = await api.post(GETRESTURENT_API,data);
        //console.log("response : ",response.data)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const SliderDetails = async (data) => {
    let result = [];
    try {
        const response = await api.post(SLIDER_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const CategoryDetails = async (data) => {
    let result = [];
    try {
        const response = await api.post(CATEGORY_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const ResturentSlug = async (slug) => {
    let result = [];
    try {
        const response = await api.post(`${SLUG_API}/${slug}`);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const ResturentSlugItem = async (slug) => {
    let result = [];
    try {
        const response = await api.post(`${SLUGITEM_API}/${slug}`);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const ResturentCategoryDetails = async (data) => {
    let result = [];
    try {
        const response = await api.post(GETRESTURENT_CATEGORY_API,data);
        //console.log("response : ",response.data)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const SingleItem = async (data) => {
    let result = [];
    try {
        const response = await api.post(SINGLE_ITEM_API,data);
        //console.log("response : ",response.data)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const Checkout = async (data) => {
    let result = [];
    try {
        const response = await api.post(CHECKOUT_API,data);
        //console.log("response : ",response.data)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getRegister = async (data) => {
    let result = [];
    try {
        const response = await api.post(REGISTER_API,data);
        //console.log("response : ",response.data)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getLogin = async (data) => {
    let result = [];
    try {
        const response = await api.post(LOGIN_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getProfile = async (data) => {
    let result = [];
    try {
        const response = await api.post(GETPROFILE_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getPages = async () => {
    let result = [];
    try {
        const response = await api.post(GETPAGES_API);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const saveAddress = async (data) => {
    let result = [];
    try {
        const response = await api.post(SAVEADDRESS_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getAvature = async (data) => {
    let result = [];
    try {
        const response = await api.post(AVATURE_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getAddress = async (data) => {
    let result = [];
    try {
        const response = await api.post(GETADDRESS_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const deleteAddress = async (data) => {
    let result = [];
    try {
        const response = await api.post(DELETEADDRESS_API,data);
        //console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        //console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getOrder = async (data) => {
    let result = [];
    try {
        const response = await api.post(MYORDER_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const addRemoveFavorite = async (data) => {
    let result = [];
    try {
        const response = await api.post(ADDFAVORITE_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getFavorite = async (data) => {
    let result = [];
    try {
        const response = await api.post(FAVORITE_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getWallet = async (data) => {
    let result = [];
    try {
        const response = await api.post(WALLET_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const getCoupon = async (data) => {
    let result = [];
    try {
        const response = await api.post(COUPON_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const codPayment = async (data) => {
    let result = [];
    try {
        const response = await api.post(PAYMENT_API,data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}
export const createOrder = async (data) => {
    let result = [];
    try {
        // const response = await api.post(PLACEORDER_API,data);
        const response = await api.post(PLACEORDER_API, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log("response : ",response)
        result = response;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const cancelOrder = async (data) => {
    let result = [];
    try {
        const response = await api.post(CANCELORDER_API, data);
        console.log("response : ",response)
        result = response.data;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}

export const setDefaultAddress = async (data) => {
    let result = [];
    try {
        const response = await api.post(DEFAULTADDRESS_API, data);
        console.log("response : ",response)
        result = response;
    }
    catch(error) {
        console.log("GET_RESTURENT_API_ERROR : ",error)
    }
    return result;
}